import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { REMOVE_APP_SUBSCRIPTION_RESOURCE } from '../../constants';

const RemoveAppSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_APP_SUBSCRIPTION_RESOURCE,
      method: 'delete',
      request: (body, callback, t) => ({
        url: apiRoutes.organisationApps(),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeAppSubscriptionFailed'),
            onSuccessMessage: t('removeAppSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveAppSubscriptionService;
